import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/purchasing',
    children: [
      { path: '', redirect: '/purchasing/home' },
      { path: 'home', name: 'purchasing-home', component: () => import('@/modules/purchasing/PurchasingHome.vue') },
      { path: 'pr', name: 'purchasing-pr', component: () => import('@/modules/purchasing/PrCenter.vue') },
      { path: 'rfq', name: 'purchasing-rfq', component: () => import('@/modules/purchasing/RfqCenter.vue') },
      { path: 'po', name: 'purchasing-po', component: () => import('@/modules/purchasing/PoList.vue') },
      { path: 'po-new', name: 'purchasing-po-new', component: () => import('@/modules/purchasing/PoCreate.vue') },
      { path: 'supplier', name: 'purchasing-supplier', component: () => import('@/modules/purchasing/SupplierList.vue') },
      { path: 'suppliers', name: 'purchasing-suppliers', component: () => import('@/modules/purchasing/SupplierList.vue') }
    ]
  }
]

export default routes
